import React, { useContext, useMemo } from "react";
import AttributeInputField from "components/attributes/compare-table/attribute-input-field";
import ReferenceField from "components/attributes/compare-table/reference-field";
import { AttributeTitle } from "./attribute-title";
import { findField } from "components/attributes/compare-table/field-builder";
import { useColumnTemplate } from "shared/hooks/use-column-template";

import { TaskContext } from "contexts/task";
import { useAttributes } from "shared/hooks/use-attributes";
import "./compare-table.scss";
import { AttributeFeedback } from "../attribute-feedback";
import { isAttributeFeedbackSupported } from "../attribute-feedback/lib/helpers";

const AttributeRow = ({
    attr,
    removeAttribute,
    readOnlyOverride,
    references,
    columnWidths,
    isReadOnlyAdd,
    isReadOnlyEdit,
    isReadOnlyDelete,
    isCompleted,
    roleTaskType,
    isBrandVerified,
}) => {
    const gridTemplate = useColumnTemplate(references.length + 2, columnWidths, references.length === 0);
    const { task } = useContext(TaskContext);
    const { data: attributesData } = useAttributes();
    const isReadOnly = task.isCompleted || (attr.readOnly && !readOnlyOverride) || isCompleted;
    const Field = useMemo(() => findField(attr.componentType, isReadOnly), [attr.componentType, isReadOnly]);
    const isReadonlyOnTaskType = !!attr.readonlyOnTaskType && !attr.required;
    const showFeedback = isAttributeFeedbackSupported(attr, task.taskType) && attributesData.hasOwnProperty(attr.uuid);

    return (
        <div
            id={attr.key}
            className="product-compare-row"
            style={gridTemplate}
        >
            <AttributeTitle
                title={attr.name}
                attr={attr}
                removeAttribute={removeAttribute}
                codingWipKey={task.context.codingWipKey}
                isCompleted={task.isCompleted}
                isReadOnlyAdd={isReadOnlyAdd}
                isReadOnlyDelete={isReadOnlyDelete}
                isBrandVerified={isBrandVerified}
            />
            <div
                data-testid="attribute-feedback-cell"
                className={showFeedback ? "attribute-feedback-cell" : undefined}
            >
                <div
                    data-testid="attribute-feedback-field"
                    className={showFeedback ? "attribute-feedback-field" : undefined}
                >
                    <AttributeInputField
                        key={`AIF_${attr.uuid}`}
                        Field={Field}
                        isReadOnly={attr.readOnly && !readOnlyOverride}
                        upc={task.upc}
                        attribute={attr}
                        isCompleted={task.isCompleted}
                        photoWipKey={task.context.photographyWipKey}
                        codingWipKey={task.context.codingWipKey}
                        disabled={isReadOnlyEdit || isReadonlyOnTaskType}
                        taskType={roleTaskType}
                    />
                </div>
                {showFeedback && (
                    <AttributeFeedback
                        attr={attr}
                        taskType={task.taskType}
                        taskKey={task.key}
                        canEdit={!task.isCompleted}
                    />
                )}
            </div>
            {references.map((r, i) => {
                return (
                    <ReferenceField
                        key={`ROF_${attr.uuid}_ref${i}`}
                        value={r[attr.uuid]}
                        attribute={attr}
                        readOnlyOverride={readOnlyOverride}
                        isCompleted={task.isCompleted}
                        upc={r.upc}
                    />
                );
            })}
        </div>
    );
};

AttributeRow.defaultProps = {
    references: [],
};

export default AttributeRow;
